// extracted by mini-css-extract-plugin
export default {"gravatarIcon":"eventCommentNotificationBlock_gravatarIcon__hbNL3","comment":"eventCommentNotificationBlock_comment__3+3jf"};